// Mock data for JorDievoorje site

export const brand = {
  wallpaper:
    'https://customer-assets.emergentagent.com/job_jordie-next/artifacts/h5b4olzo_wallpaper.png',
  character:
    'https://customer-assets.emergentagent.com/job_jordie-next/artifacts/9h1la9ag_avatar%20blankk%20bold.png'
};

export const streamer = {
  name: 'JorDievoorje',
  tagline: 'Matige streamer, maar oefening baart kunst.',
  description:
    'Vrijdag- en zaterdagavond live op Twitch. Variety gaming, pirate trips en veel te lange potjes.',
  avatar:
    'https://images.unsplash.com/photo-1542751371-adc38448a05e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx2aWRlbyUyMGdhbWV8ZW58MHx8fHwxNzgwODI3NDI0fDA&ixlib=rb-4.1.0&q=85&w=400',
  socials: {
    twitch: 'https://www.twitch.tv/jordievoorje',
    youtube: 'https://www.youtube.com/@jordievoorje',
    discord: 'https://discord.gg/ZwhnbqXGmZ',
    email: 'contact@jordievoorje.nl',
    tiktok: 'https://www.tiktok.com/@jordievoorje',
    instagram: 'https://www.instagram.com/jordievoorje',
    kick: 'https://kick.com/jordievoorje',
    twitter: 'https://x.com/jordievoorje'
  }
};

export const live = {
  isLive: false,
  title: '',
  category: '',
  startedAt: '',
  viewers: 0,
  thumb: ''
};

export const stats = [
  { label: 'Volgers', value: '—' },
  { label: 'Subs', value: '—' },
  { label: 'Game', value: '—' },
  { label: 'Status', value: '—' }
];

export const schedule = [
  { day: 'Maandag', status: 'off', game: null, time: null },
  { day: 'Dinsdag', status: 'on', game: 'Sea of Thieves', time: '20:00 - 23:00' },
  { day: 'Woensdag', status: 'off', game: null, time: null },
  { day: 'Donderdag', status: 'maybe', game: 'Variety', time: '21:00 - late' },
  { day: 'Vrijdag', status: 'on', game: 'Battlefield 6', time: '20:00 - laat' },
  { day: 'Zaterdag', status: 'on', game: 'Community Night', time: '20:00 - laat' },
  { day: 'Zondag', status: 'off', game: null, time: null }
];

export const games = [
  {
    name: 'Sea of Thieves',
    hours: 412,
    art: 'https://images.unsplash.com/photo-1625509972901-9c6c8e8d1069?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxwaXJhdGUlMjBzaGlwfGVufDB8fHx8MTc4MDgyNzQwN3ww&ixlib=rb-4.1.0&q=85&w=600',
    tag: 'Favoriet'
  },
  {
    name: 'Battlefield 6',
    hours: 78,
    art: 'https://images.pexels.com/photos/7915226/pexels-photo-7915226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    tag: 'Nieuw'
  },
  {
    name: 'Trackmania',
    hours: 145,
    art: 'https://images.unsplash.com/photo-1743649978995-c76212449e15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxyYWNpbmclMjBnYW1lfGVufDB8fHx8MTc4MDgyNzQxM3ww&ixlib=rb-4.1.0&q=85&w=600',
    tag: 'Verslaving'
  },
  {
    name: 'Fall Guys',
    hours: 96,
    art: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1097150/library_600x900.jpg',
    tag: 'Co-op'
  },
  {
    name: 'Just Chatting',
    hours: 230,
    art: 'https://images.pexels.com/photos/7862493/pexels-photo-7862493.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    tag: 'IRL'
  },
  {
    name: 'Demonologist',
    hours: 64,
    art: 'https://static-cdn.jtvnw.net/ttv-boxart/1286840579_IGDB-285x380.jpg',
    tag: 'Horror'
  }
];

export const ytHighlights = [
  {
    id: 'y1',
    title: 'BEST Sea of Thieves momenten van 2025',
    duration: '12:34',
    views: '8.2K',
    youtubeId: 'oUFJJNQGwhk',
    thumb: 'https://images.unsplash.com/photo-1625509972901-9c6c8e8d1069?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxwaXJhdGUlMjBzaGlwfGVufDB8fHx8MTc4MDgyNzQwN3ww&ixlib=rb-4.1.0&q=85&w=800'
  },
  {
    id: 'y2',
    title: 'Mijn EERSTE win in Battlefield 6',
    duration: '8:21',
    views: '5.4K',
    youtubeId: 'L_jWHffIx5E',
    thumb: 'https://images.pexels.com/photos/28993067/pexels-photo-28993067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 'y3',
    title: 'Trackmania - Wereldrecord poging gone wrong',
    duration: '15:02',
    views: '11K',
    youtubeId: 'M7lc1UVf-VE',
    thumb: 'https://images.unsplash.com/photo-1743649978995-c76212449e15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxyYWNpbmclMjBnYW1lfGVufDB8fHx8MTc4MDgyNzQxM3ww&ixlib=rb-4.1.0&q=85&w=800'
  }
];

export const testimonials = [
  {
    name: '@SemDeKip',
    text: 'Matige streamer? Misschien. Wel de leukste community van NL.',
    avatar: 'https://i.pravatar.cc/80?img=12'
  },
  {
    name: '@PirateLisa',
    text: 'Elke dinsdag op de boot. Vaste prik. Beter dan therapie.',
    avatar: 'https://i.pravatar.cc/80?img=47'
  },
  {
    name: '@RuntimeError',
    text: 'Heb Trackmania gekocht door deze man. Spijt.',
    avatar: 'https://i.pravatar.cc/80?img=33'
  }
];
